<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title text-primary"
          ><strong>Filter Log History Users</strong></h4
        >
      </template>
      <template v-slot:body>
        <b-row>
          <b-col md="9">
            <b-row>
              <b-col md="4">
                <b-form-group label="Date Range" label-for="dateRange">
                  <date-picker
                    style="width: 100%"
                    v-model="dateRange"
                    type="date"
                    range
                    placeholder="Select date range"
                    format="DD-MM-YYYY"
                    @change="onChangeDate"
                  ></date-picker>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Role" label-for="role">
                  <v-select
                    v-model="params.roleId"
                    label="roles"
                    :options="roles"
                    :reduce="(role) => role.id"
                    placeholder="Select Role"
                    @input="fetchLogs"
                  ></v-select>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="User" label-for="user">
                  <v-select
                    v-model="userFilters"
                    multiple
                    :getOptionLabel="(user) => user.userDetail.name"
                    :options="users"
                    :reduce="(user) => user.id"
                    placeholder="Select User"
                    @input="onChangeUsers"
                  ></v-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="3" class="text-right"
            v-if="findMenuPermission(1, 'export', $route.query.menuId)">
            <button class="btn btn-success mt-4 mr-1"
              @click="onExportLogs"
              :disabled="export_loading"
            >
            <span
              v-if="export_loading"
              class="spinner-border spinner-border-sm"
            />
            <div v-else class="d-flex gap-2 align-items-center"> 
              <i class="fa fa-file-excel"></i> 
              <span>Export</span>
            </div>
          </button>
          </b-col>
        </b-row>
      </template>
    </iq-card>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title text-primary"
          ><strong>Log History Users</strong></h4
        >
      </template>
      <template v-slot:body>
        <div v-if="loading" class="text-center my-5">
          <b-spinner type="grow" label="Spinning"></b-spinner>
        </div>
        <template v-else>
          <div class="table-responsive" v-if="logs.length > 0">
            <table class="table mb-0 table-striped table-hover">
              <thead class="thead-dark">
                <tr>
                  <th width="5%" class="text-center">No</th>
                  <th width="15%">Date</th>
                  <th width="20%">User</th>
                  <th width="15%">Role</th>
                  <th width="30%">Aktivitas</th>
                  <th width="15%">IP/Browser</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in logs" :key="index">
                  <td class="text-center">{{ index + 1 }}</td>
                  <td>{{ item.date }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.role }}</td>
                  <td>{{ item.activity }}</td>
                  <td>{{ item.ip }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p v-else class="text-center my-5">No logs data found.</p>
          <b-pagination
            v-model="meta.currentPage"
            :total-rows="meta.total"
            @change="fetchLogs"
            :per-page="meta.perPage"
            first-number
            align="center"
          ></b-pagination>
        </template>
      </template>
    </iq-card>
  </b-container>
</template>

<script>
import { rolesActions, usersActions, logsActions } from '@src/Utils/helper'
import { saveAs } from 'file-saver'
import moment from 'moment'

export default {
  name: 'Logs',
  data () {
    return {
      params: {
        page: 1,
        roleId: '',
        userIds: '',
        startDate: '',
        endDate:'',
      },
      meta: {
        perPage: 50,
        currentPage: 0,
        total: 0,
        totalPage: 0
      },
      export_loading:false,
      loading: true,
      dateRange: [moment(new Date()).startOf("month").toDate(), moment(new Date()).endOf("month").toDate()],
      userFilters: [],
      roles: [],
      users: [],
      logs: []
    }
  },
  mounted () {
    this.fetchRoles()
    this.fetchUsers()
    this.fetchLogs()
  },
  methods: {
    ...rolesActions,
    ...usersActions,
    ...logsActions,
    compareDates(a, b) {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);

      if (dateA > dateB) return -1; // Return a negative value to sort in descending order
      if (dateA < dateB) return 1;  // Return a positive value to sort in ascending order
      return 0; // Dates are equal
    },
    async fetchRoles () {
      let res = await this.getRoles()
      this.roles = res.data
      this.roles.unshift({
        id: '',
        roles: 'All'
      })
    },
    async fetchUsers () {
      let { data } = await this.getUsers({ page: 1, showAll: true, perPage:1000 })
      if (data.data) {
        this.users = data.data
        this.users.unshift({
          id: '',
          userDetail: {
            name: 'All'
          }
        })
      }
    },
    async fetchLogs (page = 1) {
      this.params.page = page || 1

      this.loading = true
      let params = this.$options.filters.cleanObject(this.params)

      console.log(this.dateRange)

      if(this.dateRange[0] !== null && this.dateRange[1] !== null){
        params.startDate = moment(this.dateRange[0]).format('DD-MM-YYYY HH:mm')
        params.endDate = moment(this.dateRange[1]).format('DD-MM-YYYY HH:mm')
      } else {
        params.startDate = null
        params.endDate = null
      }

      if(!params.startDate) delete params.startDate
      if(!params.endDate) delete params.endDate
      if(!params.roleId) delete params.roleId
      if(!params.userIds) delete params.userIds

      let { data } = await this.getLogs(params)

      if (data.data) {
        this.meta.perPage = data.perPage
        this.meta.currentPage = data.currentPage
        this.meta.total = data.total
        this.meta.totalPage = data.totalPage

        this.logs = data.data.sort(this.compareDates);

        this.loading = false
      }
    },
    onChangeDate () {
      this.fetchLogs()
    },
    onChangeUsers () {
      this.params.userIds = this.userFilters.join(',')
      this.fetchLogs()
    },
    async onExportLogs(){
      this.export_loading = true
      let params = this.$options.filters.cleanObject(this.params)


      if(this.dateRange.length > 0){
        params.startDate = moment(this.dateRange[0]).format('DD-MM-YYYY HH:mm')
        params.endDate = moment(this.dateRange[1]).format('DD-MM-YYYY HH:mm')
      }
      
      const res = await this.exportLogs(params)

      if(res.status !== "success"){
        this.$swal(`Oops!`, `Something went wrong.`, 'error')
        this.export_loading = false
        return
      }
      saveAs(res.data, 'Logs Users.xlsx')
      this.export_loading = false
    }
  }
}
</script>

<style scoped>
</style>
